import client from './client'
import headerAuthorization from './headerAuthorization'

const correoService = {}

correoService.correoConfig = function (token) {
  return client.get(
    `/correo/configuracion`,
    headerAuthorization(token)
  )
    .then(res => res.data).catch(error => {
      console.error(error.stack)
    })
}

correoService.correoConfigActualizar = function (data, token) {
  return client.put(
    `/correo/configuracion/actualizar`,
    data,
    headerAuthorization(token)
  )
    .then(res => res.data)
}

export default correoService